import { useState, useEffect } from 'react';
import { ShopIcon, CartIcon, OrderIcon, HeartIcon, AccountIcon } from './Icons';

const navItems = [
  { id: 'shop', label: 'Shop', Icon: ShopIcon },
  { id: 'cart', label: 'Cart', Icon: CartIcon },
  { id: 'orders', label: 'Orders', Icon: OrderIcon },
  { id: 'wishlist', label: 'Wishlist', Icon: HeartIcon },
  { id: 'account', label: 'Account', Icon: AccountIcon },
];

export default function BottomNav({ activePage, onNavigate, badges = {} }) {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.visualViewport) {
        setIsKeyboardOpen(window.visualViewport.height < window.innerHeight - 150);
      }
    };
    
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleResize);
      return () => window.visualViewport.removeEventListener('resize', handleResize);
    }
  }, []);

  if (isKeyboardOpen) return null;

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 z-50" style={{ paddingBottom: 'env(safe-area-inset-bottom, 8px)' }}>
      <div className="flex items-center justify-around py-1.5">
        {navItems.map(({ id, label, Icon }) => {
          const isActive = activePage === id;
          const badgeCount = badges[id] || 0;
          return (
            <button
              key={id}
              onClick={() => onNavigate(id)}
              className="flex flex-col items-center gap-0.5 px-3 py-1 min-w-0 relative"
            >
              <div className="relative">
                <Icon
                  className={`w-5 h-5 ${isActive ? 'text-[#F47B20]' : 'text-gray-400'}`}
                />
                {badgeCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[9px] font-black min-w-[16px] h-4 px-0.5 rounded-full flex items-center justify-center border border-white shadow-sm">
                    {badgeCount > 9 ? '9+' : badgeCount}
                  </span>
                )}
              </div>
              <span className={`text-[10px] ${isActive ? 'text-[#F47B20] font-semibold' : 'text-gray-400'}`}>
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
